export const getEntities = state => state.entities
export const getUsers = state => state.entities.get('users')
export const getSystems = state => state.entities.get('systems')
export const getDevice = state => state.entities.get('device')
export const getLastVersions = state => state.entities.get('lastVersions')
